import { coreActions } from '@sonar-software/sonar-core';
import { isEqual } from 'lodash';
import { SonarText } from '@ui/text';
import { Space } from 'antd';
import { UserSelector } from '@ui/UserSelector';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useTagReference } from '@hooks';
export const TagOwnersSection = ({ tagId }) => {
    const tag = useTagReference(tagId);
    const requestPut = useAction(coreActions.requestPutCoreTagsById);
    const handleChange = useCallback((owners) => {
        if (tagId && !isEqual(tag.ownerIds, owners)) {
            requestPut(Object.assign(Object.assign({}, tag), { ownerIds: owners !== null && owners !== void 0 ? owners : [] }));
        }
    }, [requestPut, tag, tagId]);
    return (React.createElement(Space, { className: 'tag-owner-section', direction: 'vertical', size: 4 },
        React.createElement(SonarText, { size: 16, weight: 'semibold' }, COPY_SPECIFIC.OWNERS),
        React.createElement(UserSelector, { direction: 'horizontal', disabled: tag.autoTagged, mode: 'multiple', onMultipleChange: handleChange, placeholder: PLACEHOLDERS_COPY.ADD_OWNER, showSearch: false, value: tag.ownerIds })));
};
